import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import Component from '@glimmer/component';
import type { SelectOption } from 'donor-elf-web/lib/form-component-utils';
import FundMappingsService from 'donor-elf-web/services/fund-mappings-service';

interface FundMappingHostIdentityArgs {
  changeset: any;
  allChangesets: any[];
  showValidationErrors: boolean;
  onDelete: () => void;
}

export default class FundMappingHostIdentityComponent extends Component<FundMappingHostIdentityArgs> {
  @service declare fundMappingsService: FundMappingsService;

  get databaseOptions() {
    let options = this.fundMappingsService.availableDatabaseOptions.slice();
    if (isEmpty(this.args.changeset.get('database'))) {
      options.unshift({ val: undefined, label: '' });
    }
    return options;
  }

  get selectedDatabaseHasHostFunds() {
    return (
      this.fundMappingsService.hostFundsByDatabaseAndHostId[
        this.args.changeset.get('database')
      ] != null
    );
  }

  get otherChangesets() {
    return this.args.allChangesets.filter((x) => x !== this.args.changeset);
  }

  get hostIdOptions(): SelectOption[] {
    // filter out hostIds that are already in use by other changesets
    return this.fundMappingsService.databaseHostFundOptions[
      this.args.changeset.get('database')
    ]?.filter((x) => {
      return !this.otherChangesets.some((y) => y.get('hostId') === x.val);
    });
  }
}
